import React from "react"
import { RouteComponentProps } from "@reach/router"
import { IFrame } from "../../integration/iframe"

export const BrokerClaims: React.FC<RouteComponentProps> = () => (
  <>
    <IFrame path="claims" />
  </>
)
